export const SELECTION_MODES = {
  CURRICULAR: 'analise_curricular',
  PROVA: 'prova',
  ORDEM_INSCRICAO: 'ordem_inscricao',
  CARTA_INTENCAO: 'carta_intencao',
  BAREMA: 'barema',
  SORTEIO: 'sorteio',
};

export const SELECTION_MODE_CATALOG = [
  {
    id: SELECTION_MODES.CURRICULAR,
    label: 'Análise curricular',
    implemented: true,
    description: 'Análise de documentos e notas curriculares.',
  },
  {
    id: SELECTION_MODES.ORDEM_INSCRICAO,
    label: 'Por ordem de inscrição',
    implemented: true,
    description: 'Classificação pela ordem de inscrição (com análise documental).',
  },
  {
    id: SELECTION_MODES.PROVA,
    label: 'Prova',
    implemented: true,
    description: 'Seleção por prova objetiva, redação e fluxos de exame.',
  },
  {
    id: SELECTION_MODES.CARTA_INTENCAO,
    label: 'Carta de intenção',
    implemented: true,
    description: 'Carta de intenção digitada pelo candidato e avaliada por barema.',
  },
  {
    id: SELECTION_MODES.BAREMA,
    label: 'Por barema',
    implemented: false,
    description: 'Classificação por barema (em desenvolvimento).',
  },
  {
    id: SELECTION_MODES.SORTEIO,
    label: 'Por sorteio',
    implemented: false,
    description: 'Seleção por sorteio (em desenvolvimento).',
  },
];

export const SELECTION_MODE_LABELS = Object.fromEntries(
  SELECTION_MODE_CATALOG.map((m) => [m.id, m.label])
);

export const IMPLEMENTED_SELECTION_MODES = SELECTION_MODE_CATALOG.filter((m) => m.implemented).map((m) => m.id);

export const DEFAULT_CONTRACTED_MODES = [...IMPLEMENTED_SELECTION_MODES];

export function normalizeSelectionMode(mode) {
  const s = String(mode || SELECTION_MODES.CURRICULAR).trim().toLowerCase();
  if (s === SELECTION_MODES.PROVA) return SELECTION_MODES.PROVA;
  if (s === SELECTION_MODES.ORDEM_INSCRICAO || s === 'ordem de inscrição' || s === 'ordem de inscricao') {
    return SELECTION_MODES.ORDEM_INSCRICAO;
  }
  if (s === SELECTION_MODES.CARTA_INTENCAO || s === 'carta de intenção' || s === 'carta de intencao') {
    return SELECTION_MODES.CARTA_INTENCAO;
  }
  if (s === SELECTION_MODES.BAREMA || s === 'por barema') return SELECTION_MODES.BAREMA;
  if (s === SELECTION_MODES.SORTEIO || s === 'por sorteio') return SELECTION_MODES.SORTEIO;
  return SELECTION_MODES.CURRICULAR;
}

export function isProvaMode(mode) {
  return normalizeSelectionMode(mode) === SELECTION_MODES.PROVA;
}

export function isOrdemInscricaoMode(mode) {
  return normalizeSelectionMode(mode) === SELECTION_MODES.ORDEM_INSCRICAO;
}

export function isIntentionLetterMode(mode) {
  return normalizeSelectionMode(mode) === SELECTION_MODES.CARTA_INTENCAO;
}

export function isCurricularLikeMode(mode) {
  const m = normalizeSelectionMode(mode);
  return m === SELECTION_MODES.CURRICULAR || m === SELECTION_MODES.ORDEM_INSCRICAO || m === SELECTION_MODES.CARTA_INTENCAO;
}

export function requiresCurricularDocuments(mode) {
  const m = normalizeSelectionMode(mode);
  return m === SELECTION_MODES.CURRICULAR || m === SELECTION_MODES.ORDEM_INSCRICAO;
}

export function requiresIntentionLetterText(mode) {
  return isIntentionLetterMode(mode);
}

export function requiresCurricularSubjectsMatrix(mode) {
  return normalizeSelectionMode(mode) === SELECTION_MODES.CURRICULAR;
}

export function requiresGradeAnalysis(mode) {
  const m = normalizeSelectionMode(mode);
  return m === SELECTION_MODES.CURRICULAR || m === SELECTION_MODES.CARTA_INTENCAO;
}

export function getSelectionModeLabel(mode) {
  return SELECTION_MODE_LABELS[normalizeSelectionMode(mode)] || mode || '—';
}

export function getCatalogEntry(mode) {
  const id = normalizeSelectionMode(mode);
  return SELECTION_MODE_CATALOG.find((m) => m.id === id);
}
